const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

const Analytics = {
  setUser: (user) => {
    // drift
    window.drift.reset();
    window.drift.identify(user.id, {
      name: user.name,
      email: user.email,
      phone: user.phone,
      stripeCustomerId: user.stripeCustomerId,
      env: process.env.REACT_APP_ENV,
      tags: [process.env.REACT_APP_ENV, "Customer"]
    });
    // gtag
    window.gtag('set', { 'user_id': user.id });
  },
  setUserAttributes: (attributes) => {
    window.drift.api.setUserAttributes(attributes);
  },
  trackPage: (path) => {
    window.gtag('config', GA_TRACKING_ID, { 'page_path': path });
  },
  trackEvent: (name, props) => {
    window.gtag('event', name, props);
  },
  clearUser: () => {
    window.gtag('set', { 'user_id': void 0 });
    const t = document.getElementById("drift-widget-container");
    if (t) { window.drift.reset(); }
  },
}

export default Analytics;


// WEBPACK FOOTER //
// ./src/tools/Analytics.js